exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MuiChip-root .MuiChip-label {\n  padding: 10px !important;\n}\n\n.table .MuiChip-root .MuiChip-label {\n  padding: 8px !important;\n  margin-right: 3px !important;\n}", ""]);
